import React from "react";
import { Controller } from "react-hook-form";
import ReactStars from "react-rating-stars-component";

interface InputFieldProps {
  control: any;
  name: string;
  rules?: object;
  placeholder: string;
  setIsDisabled?: any;
  title: string;
  isDisabled: boolean;
  isValue?: boolean;
}

const RatingBar: React.FC<InputFieldProps> = ({
  control,
  name,
  rules = {},
  placeholder,
  title,
  isDisabled,
  isValue,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <div className="">
          <div className="flex items-center   justify-between">
            <p className="text-xs mb-2">{title}</p>
          </div>
          <ReactStars
            count={10}
            edit={!isDisabled}
            value={value}
            onChange={(e: any) => onChange(e)}
            size={30}
            isHalf={true}
            emptyIcon={
              <i className="far fa-star border border-solid   border-black "></i>    }
            halfIcon={<i className="fa fa-star-half-alt"></i>}
            fullIcon={<i className="fa fa-star"></i>}
            activeColor="#cb0e5f"
          />

          {error && (
            <span className="text-red-500 text-xs self-stretch">
              {error.message || "Error"}
            </span>
          )}
        </div>
      )}
    />
  );
};

export default RatingBar;
